(function() {

// Disable Replication
  document.addEventListener('contextmenu', function(e) {
      e.preventDefault();
    }, false);
  
  document.addEventListener('keydown', function(e) {
      // Disable Replication Ctrl+C And Cmd+C（macOS）
    if ((e.ctrlKey || e.metaKey) && e.keyCode === 67) {
       e.preventDefault();
    }
    // Disable Replication Ctrl+U And Cmd+U（Vcode）
    if ((e.ctrlKey || e.metaKey) && e.keyCode === 85) {
        e.preventDefault();
    }
  }, false);

})()